import { createStyles } from "@material-ui/styles";

const styles = () =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end"
        },
        wrapper: {
            display: "flex",
            borderRadius: "6px",
            overflow: "hidden",
            width: "100%",
            height: "52px",
            background: "#F7FAFC",
            border: "2px solid transparent",

            "&.error": {
                borderColor: "#FF0C0C"
            },

            "& .PhoneInput ": {
                width: "100%",

                "& .PhoneInputCountry": {
                    background: "#f8fafc",
                    width: "60px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 0
                },

                "& .PhoneInputInput": {
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    border: "none",
                    padding: "0 16px",
                    color: "#153862",
                    fontFamily: "inherit",
                    background: "#F7FAFC",
                    outline: "none",
                    fontSize: "19px"
                }
            }
        },
        error: {
            color: "#f44336",
            fontSize: "12px"
        }
    });

export default styles;



// WEBPACK FOOTER //
// ./src/components/StartContainer/components/phoneInput.style.js